import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6f081010")

_pushScopeId("data-v-6f081010")
const _hoisted_1 = { class: "bg-ff content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      "label-width": "100px",
      model: _ctx.form,
      rules: _ctx.rules
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form_item, {
          label: "原密码",
          prop: "primary_password"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              "show-password": "",
              class: "password-input",
              modelValue: _ctx.form.primary_password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.primary_password = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "新密码",
          prop: "new_password"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              "show-password": "",
              class: "password-input",
              modelValue: _ctx.form.new_password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.new_password = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "确认密码",
          prop: "confirm_password"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              "show-password": "",
              class: "password-input",
              modelValue: _ctx.form.confirm_password,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.confirm_password = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "" }, {
          default: _withId(() => [
            _createVNode(_component_el_button, {
              class: "bg-red mar-r-8",
              onClick: _ctx.passwordChange
            }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
})